<template>
	<div>
		


		<panel class="border border-secondary rounded mb-4" :noButton="true">
			<template slot="header">
				<h5>Konfirmasi Pengecekan Barang Interior</h5>
			</template>
			<!-- {{checkSettingsChecklist}} -->
			<h6>Opsi Pengecekan Barang</h6>
			<button class="btn btn-info mb-4" @click="allChecklist">Semua Sesuai</button>

			<div v-if="checkSettingsChecklistCopied">
				<div class="row" v-if="checkSettingsFormatted">
					<div class="col-md-6 col-12" v-for="keys in Object.keys(checkSettingsFormatted)" :key="keys">
						<h5>{{keys}}</h5>
						<ul>
							<li v-for="data in checkSettingsFormatted[keys]" :key="data.img" >
								<!-- {{checkSettingsChecklistCopied}} -->
								<div class=" mb-2 mt-2" v-if="checkSettingsChecklistCopied[data.variable]">
									<div class="row">
										<div class="col-4">
											
											<img :src="data.img" style="width:75px;height:75px" />
											
										</div>
										<div class="col-8" v-if="checkSettingsChecklistCopied[data.variable]">
											<h6 style="color:black;">{{data.name}}</h6>
											<p>Kondisi Barang : {{checkSettingsChecklistCopied[data.variable].condition}}</p>
											<p>Deskripsi : {{checkSettingsChecklistCopied[data.variable].desc}}</p>
										</div>
										<!-- <input type="radio" v-model="checkSettingsChecklistCopied[data.variable].check"/> -->
										<div class="col-3 text-center">
											<input type="radio" id="one" value="Sesuai" v-model="checkSettingsChecklistCopied[data.variable].check">
											<label for="one">Sesuai</label>
										</div>
										<div class="col-3 text-center">
											<input type="radio" id="one" value="Tidak Sesuai" v-model="checkSettingsChecklistCopied[data.variable].check">
											<label for="one">Tidak Sesuai</label>
										</div>
									</div>
									<hr>
								</div>
								

								

							</li>
						</ul>
					</div>
				</div>
			</div>
			<div v-else class="mt-5 mb-5 text-center">
				<h3>Tidak Ada Pengeecekan Kondisi</h3>
			</div>

			<div class="mt-3 mb-3 " v-if="updateSubmit.endProcess != 0">
				<h5>Processing. Please Wait.</h5>
				<b-progress :value="updateSubmit.curProcess" :max="updateSubmit.endProcess" show-progress animated height="2rem" >
					<b-progress-bar :value="updateSubmit.curProcess" >
						<span>Progress: <strong>{{ updateSubmit.curProcess }} / {{ updateSubmit.endProcess }}</strong></span>
					</b-progress-bar>
				</b-progress>
			</div>

			<div class="row" >
			<div class="col-md-6 col-0">
			</div>
			<div class="col-md-3 col-6">
				<button type="button" class="btn btn-danger w-100 rounded" @click="$emit('backPage');">Sebelumnya</button>
			</div>
			<div class="col-md-3 col-6" >
				<button type="button" class="btn btn-success w-100 rounded" @click="nextPage" :disabled="updateSubmit.endProcess != 0">
					<span >Selesai</span>
					<!-- <template v-else>
						<span class="spinner-grow spinner-grow-sm"></span>
						Loading..
					</template> -->
				</button>
			</div>
		</div>
		</panel>
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import modalUploadImage from './modalUploadImage'
	import moment from 'moment'
	import modalUploadImageCheckList from './modalUploadImageChecklist.vue'

	export default {
		components: {
			Multiselect,
			modalUploadImage,
			modalUploadImageCheckList

		},
		data () {
			return {
				showModal: false,
				part: '',
				partHeader : '',
				showFrontModal: false,
				carTypes : this.carType,
				checkSettings : this.data.condition.checklist,
				checkSettingsFormatted : null,
				checkSettingsChecklistCopied : null,
				showCheckListModal : false
			}
		},
		props: ['page', 'data', 'checklistSettings' , 'carType','form_code', 'checkSettingsChecklist' , 'updateSubmit'],
		mounted () {
			this.checkSettingsChecklistCopied = JSON.parse(JSON.stringify(this.checkSettingsChecklist))

			let keys = Object.keys(this.checkSettingsChecklistCopied)

			for(var i = 0 ; i < keys.length ; i++) {
				if(!this.checkSettingsChecklistCopied[keys[i]]) {
					this.checkSettingsChecklistCopied[keys[i]] = {
						condition: "Tidak Diketahui",
						desc: "Tidak Diketahui"
					}
				}
				// console.log(this.checkSettingsChecklistCopied[keys[i]] , keys[i])
				this.$set(this.checkSettingsChecklistCopied[keys[i]], 'check' , null)
			}
			this.seperate()
		},
		methods: {
			modalUploadImageCheckList (variable , data) {
				this.checkSettings[variable] = data
				this.showCheckListModal = false
			},
			seperate () {
				let list = this.checklistSettings
				console.log(list)

				let newList = {
					'BARANG' : [] , 
					'FRONT' : [] , 
					'INTERIOR' : [],
					'REAR' : [] , 
					'LEFT' : [] , 
					'RIGHT' : [] , 
					'ATAP' : []
				}

				for(var i = 0 ; i < list.length ; i ++) {
					let location  = list[i].name.split('_')[0]
					let obj = {
						img : list[i].img ? list[i].img :  '/img/WorkOrder/Logo/' + list[i].name.split("_")[1] + '.png',
						name : list[i].name.split("_")[1],
						variable : list[i].name
					}

					newList[location].push(obj)
					// console.log(newList)

				}
				this.checkSettingsFormatted = newList

			},
			checked(part) {
				// console.log(part)
				if(this.checkSettings[part])
					this.checkSettings[part] = !this.checkSettings[part]
				else {
					this.showCheckListModal = true
					this.part = part
				}
			},
			selectPart (part , carType) {

				let partString = part.split('.')
				

				
				if(this.data.condition.figure[carType][partString[0]][partString[1]]  && this.data.condition.figure[carTypes][partString[0]][partString[1]] != true ) {
					this.data.condition.figure[carType][partString[0]][partString[1]] = false
				}
				else {
					this.showModal = true
					this.part = partString[1]
					this.partHeader = 'figure'
				}
			},
			uploadImage (partHeader , part, url) {
				if(partHeader != 'figureOverall')
					this.data.condition[partHeader][this.carType].right[part] = url
				else 
					this.data.condition[partHeader][this.carType][part] = url
				// alert("Unggah Gambar Berhasil!")
				this.$store.dispatch('triggerAlert', [true, ['Unggah Gambar Berhasil']])
				this.showModal = false

				if(partHeader == 'figureOverall')
					this.createWorkOrder()
			},
			translatePart (str) {
				let strSplit = str.split("_").reverse()

				for (var i = 0 ; i < strSplit.length ; i ++) {
					
					if(strSplit[i] == 'front')
						strSplit[i] = 'depan'
					else if (strSplit[i] == 'rear')
						strSplit[i] = 'belakang'
					else if (strSplit[i] == 'left')
						strSplit[i] = 'kiri'
					else if (strSplit[i] == 'right')
						strSplit[i] = 'kanan'
					else if (strSplit[i] == 'wheel')
						strSplit[i] = 'roda'
					else if (strSplit[i] == 'door')
						strSplit[i] = 'pintu'
					else if (strSplit[i] == 'light')
						strSplit[i] = 'lampu'

					strSplit[i] = strSplit[i].charAt(0).toUpperCase() + strSplit[i].slice(1)
				}

				return strSplit.join(" ")
			},
			async nextPage () {

				let check = await this.checkAllChecklist()
				if(!check) {
					this.$store.dispatch('triggerAlert' , [false , 'Mohon untuk mengecek semua barang sesuai atau tidak sesuai dengan deskripsi tanda terima'])
					return
				}
				this.$emit('nextPage' , this.checkSettingsChecklistCopied)
			},
			allChecklist() {
				let keys = Object.keys(this.checkSettingsChecklistCopied)
				for(var i = 0 ; i <keys.length ; i++) {
					if(this.checkSettingsChecklistCopied[keys[i]]) {
						console.log(keys[i])
						this.checkSettingsChecklistCopied[keys[i]].check = 'Sesuai'
					}
				}
			},
			checkAllChecklist () {
				let check = true
				let keys = Object.keys(this.checkSettingsChecklistCopied)
				for(var i = 0 ; i <keys.length ; i++) {
					if(this.checkSettingsChecklistCopied[keys[i]] && !this.checkSettingsChecklistCopied[keys[i]].check) {
						console.log(keys[i])
						check = false
						break;
					}
				}

				return check
			}
 		}
	}
</script>
